(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundleSection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBundle(wrapper) {

      var maxItems   = parseInt(wrapper.dataset.max, 10);
      var currency   = wrapper.dataset.currency || 'INR';
      var locale     = wrapper.dataset.locale || 'en-IN';
      var btnLabel   = wrapper.dataset.buttonLabel || 'Buy Now';
      var btnLoading = wrapper.dataset.buttonLoading || 'Processing...';
      var errorMsg   = wrapper.dataset.errorMessage || 'Something went wrong.';
      var clearSelectionAfterAdd = String(wrapper.dataset.clearSelection || 'false') === 'true';
      var offerText2 = wrapper.dataset.offerText2 || 'Buy Any 2 @ 2299';
      var offerText3 = wrapper.dataset.offerText3 || 'Buy Any 3 @ 3099';
      var offerCap2 = parseInt(wrapper.dataset.offerCap2, 10);
      var offerCap3 = parseInt(wrapper.dataset.offerCap3, 10);
      var saveLabel = wrapper.dataset.saveLabel || 'Save';

      if (isNaN(offerCap2) || offerCap2 < 0) offerCap2 = 2299;
      if (isNaN(offerCap3) || offerCap3 < 0) offerCap3 = 3099;

      var COMBO_OFFERS = [
        { qty: 2, cap: offerCap2 * 100, label: offerText2 },
        { qty: 3, cap: offerCap3 * 100, label: offerText3 }
      ];

      var countEls = wrapper.querySelectorAll('.bundle-count');
      var totalEl  = wrapper.querySelector('.bundle-total');
      var addBtn   = wrapper.querySelector('.bundle-add');
      var addBtnLabel = wrapper.querySelector('.bundle-add-label');
      var fillEl   = wrapper.querySelector('.bundle-progress-fill');
      var offerEl  = wrapper.querySelector('.bundle-offer-tag');
      var totalNoteEl = wrapper.querySelector('.bundle-total-note');
      var toastHost = wrapper.querySelector('.bundle-toasts');
      var maxEls = wrapper.querySelectorAll('.bundle-max');
      var duoStripEl = wrapper.querySelector('.bundle-strip-duo');
      var trioStripEl = wrapper.querySelector('.bundle-strip-trio');
      var stripDotEl = wrapper.querySelector('.bb-strip-dot');
      var quickView = wrapper.querySelector('.bundle-quickview');
      var quickViewTitle = wrapper.querySelector('.bundle-qv-title');
      var quickViewTrack = wrapper.querySelector('.bundle-qv-track');
      var quickViewDots = wrapper.querySelector('.bundle-qv-dots');
      var quickViewPrev = wrapper.querySelector('.bundle-qv-prev');
      var quickViewNext = wrapper.querySelector('.bundle-qv-next');
      var quickViewProductTitle = wrapper.querySelector('.bundle-qv-product-title');
      var quickViewProductMeta = wrapper.querySelector('.bundle-qv-product-meta');
      var quickViewProductDesc = wrapper.querySelector('.bundle-qv-product-desc');
      var quickViewPrice = wrapper.querySelector('.bundle-qv-price');
      var quickViewOptions = wrapper.querySelector('.bundle-qv-options');
      var quickViewAddBtn = wrapper.querySelector('.bundle-qv-add');
      var quickViewCloseEls = wrapper.querySelectorAll('[data-qv-close]');

      var state = {};
      var quickViewState = null;
      var quickViewCloseTimer = null;

      if (!addBtn || isNaN(maxItems) || maxItems < 1) return;

      var urlText = ((window.location.pathname || '') + (window.location.search || '')).toLowerCase();
      var activeMaxItems = maxItems;

      if (urlText.indexOf('savemore-duo') !== -1 || urlText.indexOf('save-more-duo') !== -1 || urlText.indexOf('bundle-duo') !== -1) {
        activeMaxItems = 2;
      } else if (urlText.indexOf('savemore-trio') !== -1 || urlText.indexOf('save-more-trio') !== -1 || urlText.indexOf('savemore-3') !== -1 || urlText.indexOf('bundle-3') !== -1 || urlText.indexOf('bundle-trio') !== -1) {
        activeMaxItems = 3;
      }

      maxEls.forEach(function (el) { el.textContent = String(activeMaxItems); });
      if (duoStripEl && trioStripEl && stripDotEl) {
        if (activeMaxItems === 2) {
          trioStripEl.style.display = 'none';
          stripDotEl.style.display = 'none';
        } else if (activeMaxItems === 3) {
          duoStripEl.style.display = 'none';
          stripDotEl.style.display = 'none';
        }
      }

      function totalCount() {
        var n = 0;
        var keys = Object.keys(state);
        for (var i = 0; i < keys.length; i++) n += state[keys[i]].qty;
        return n;
      }

      function totalPrice() {
        var p = 0;
        var keys = Object.keys(state);
        for (var i = 0; i < keys.length; i++) p += state[keys[i]].qty * state[keys[i]].price;
        return p;
      }

      function formatMoney(cents) {
        try {
          return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency });
        } catch (e) {
          return '₹' + (cents / 100).toFixed(0);
        }
      }

      function getOffer(count) {
        for (var i = 0; i < COMBO_OFFERS.length; i++) {
          if (COMBO_OFFERS[i].qty === count) return COMBO_OFFERS[i];
        }
        return null;
      }

      function showToast(message, type) {
        if (!toastHost) return;
        var toast = document.createElement('div');
        toast.className = 'bundle-toast ' + (type || 'info');
        toast.textContent = message;
        toastHost.appendChild(toast);
        setTimeout(function () {
          if (toast && toast.parentNode) toast.parentNode.removeChild(toast);
        }, 1900);
      }

      function renderQuickViewPrice(priceCents, compareAtCents) {
        if (!quickViewPrice) return;
        if (compareAtCents > priceCents) {
          quickViewPrice.innerHTML = '<s class="bundle-price-original">' + formatMoney(compareAtCents) + '</s> ' + formatMoney(priceCents);
        } else {
          quickViewPrice.textContent = formatMoney(priceCents);
        }
      }

      function closeQuickView() {
        if (!quickView) return;
        quickView.classList.remove('is-open');
        quickView.classList.add('is-closing');
        if (quickViewCloseTimer) clearTimeout(quickViewCloseTimer);
        quickViewCloseTimer = setTimeout(function () {
          quickView.hidden = true;
          quickView.classList.remove('is-closing');
          quickViewState = null;
          if (quickViewOptions) quickViewOptions.innerHTML = '';
          if (quickViewTrack) {
            quickViewTrack.onscroll = null;
            quickViewTrack.innerHTML = '';
          }
          if (quickViewDots) quickViewDots.innerHTML = '';
        }, 230);
      }

      function activeQuickViewSlide(index) {
        if (!quickViewDots) return;
        var dots = quickViewDots.querySelectorAll('.bundle-qv-dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function buildQuickViewMedia(card) {
        if (!quickViewTrack || !quickViewDots) return;
        quickViewTrack.innerHTML = '';
        quickViewDots.innerHTML = '';

        var imageNodes = card.querySelectorAll('.bundle-qv-images img');
        var imageList = [];
        imageNodes.forEach(function (img) {
          if (img && img.getAttribute('src')) {
            imageList.push({
              src: img.getAttribute('src'),
              alt: img.getAttribute('alt') || ''
            });
          }
        });

        if (!imageList.length) {
          var fallbackImg = card.querySelector('.bundle-img img');
          if (fallbackImg && fallbackImg.getAttribute('src')) {
            imageList.push({
              src: fallbackImg.getAttribute('src'),
              alt: fallbackImg.getAttribute('alt') || ''
            });
          }
        }

        imageList.forEach(function (item, idx) {
          var slide = document.createElement('div');
          slide.className = 'bundle-qv-slide';
          var img = document.createElement('img');
          img.src = item.src;
          img.alt = item.alt;
          slide.appendChild(img);
          quickViewTrack.appendChild(slide);

          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bundle-qv-dot' + (idx === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to image ' + (idx + 1));
          dot.addEventListener('click', function () {
            quickViewTrack.scrollTo({ left: idx * quickViewTrack.clientWidth, behavior: 'smooth' });
          });
          quickViewDots.appendChild(dot);
        });

        quickViewTrack.scrollLeft = 0;
        quickViewTrack.onscroll = function () {
          if (!quickViewTrack.clientWidth) return;
          var index = Math.round(quickViewTrack.scrollLeft / quickViewTrack.clientWidth);
          activeQuickViewSlide(index);
        };
      }

      function openQuickView(card, sizeDataEls) {
        if (!quickView || !quickViewOptions || !quickViewAddBtn) return false;
        if (!sizeDataEls || !sizeDataEls.length) return false;

        var initialVariantId = card.dataset.variantId;
        var productTitleEl = card.querySelector('.bundle-info h4');
        if (quickViewTitle) quickViewTitle.textContent = 'Select size';
        quickViewOptions.innerHTML = '';
        buildQuickViewMedia(card);
        if (quickViewProductTitle) quickViewProductTitle.textContent = productTitleEl ? productTitleEl.textContent.trim() : '';
        if (quickViewProductMeta) {
          var metaParts = [];
          if (card.dataset.productVendor) metaParts.push(card.dataset.productVendor);
          if (card.dataset.productType) metaParts.push(card.dataset.productType);
          quickViewProductMeta.textContent = metaParts.join(' • ');
        }
        if (quickViewProductDesc) quickViewProductDesc.textContent = card.dataset.productDescription || '';

        quickViewState = {
          card: card,
          variantId: null,
          price: 0,
          compareAt: 0
        };

        sizeDataEls.forEach(function (sizeEl, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bundle-qv-option';
          btn.textContent = sizeEl.dataset.sizeLabel || sizeEl.textContent.trim();
          btn.dataset.variantId = sizeEl.dataset.variantId;
          btn.dataset.price = sizeEl.dataset.price;
          btn.dataset.compareAt = sizeEl.dataset.compareAt || '0';

          var isDefault = (sizeEl.dataset.variantId === initialVariantId) || (sizeEl.dataset.default === 'true') || (!initialVariantId && idx === 0);
          if (isDefault) {
            btn.classList.add('is-active');
            quickViewState.variantId = btn.dataset.variantId;
            quickViewState.price = parseInt(btn.dataset.price, 10) || 0;
            quickViewState.compareAt = parseInt(btn.dataset.compareAt, 10) || 0;
          }

          btn.addEventListener('click', function () {
            quickViewOptions.querySelectorAll('.bundle-qv-option').forEach(function (node) {
              node.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            quickViewState.variantId = btn.dataset.variantId;
            quickViewState.price = parseInt(btn.dataset.price, 10) || 0;
            quickViewState.compareAt = parseInt(btn.dataset.compareAt, 10) || 0;
            renderQuickViewPrice(quickViewState.price, quickViewState.compareAt);
          });

          quickViewOptions.appendChild(btn);
        });

        if (!quickViewState.variantId) {
          var firstBtn = quickViewOptions.querySelector('.bundle-qv-option');
          if (firstBtn) {
            firstBtn.classList.add('is-active');
            quickViewState.variantId = firstBtn.dataset.variantId;
            quickViewState.price = parseInt(firstBtn.dataset.price, 10) || 0;
            quickViewState.compareAt = parseInt(firstBtn.dataset.compareAt, 10) || 0;
          }
        }

        renderQuickViewPrice(quickViewState.price, quickViewState.compareAt);
        quickView.hidden = false;
        quickView.classList.remove('is-closing');
        requestAnimationFrame(function () {
          quickView.classList.add('is-open');
        });
        return true;
      }

      function sync() {
        var n     = totalCount();
        var raw   = totalPrice();
        var offer = getOffer(n);

        countEls.forEach(function (el) { el.textContent = n; });

        if (fillEl) fillEl.style.width = Math.min((n / activeMaxItems) * 100, 100) + '%';

        if (totalEl) {
          if (offer && offer.cap > 0 && raw > offer.cap) {
            var savedAmount = raw - offer.cap;
            totalEl.innerHTML =
              '<s class="bundle-price-original">' + formatMoney(raw) + '</s> ' +
              '<span class="bundle-price-offer">' + formatMoney(offer.cap) + '</span>';
            if (totalNoteEl) totalNoteEl.textContent = saveLabel + ' ' + formatMoney(savedAmount);
          } else {
            totalEl.textContent = formatMoney(raw);
            if (totalNoteEl) totalNoteEl.textContent = '';
          }
        }

        if (offerEl) {
          if (offer && offer.cap > 0 && raw > offer.cap) {
            offerEl.textContent = offer.label + ' — ' + saveLabel + ' ' + formatMoney(raw - offer.cap) + '!';
            offerEl.style.display = 'block';
          } else {
            offerEl.style.display = 'none';
          }
        }

        var ready = (n === activeMaxItems);
        addBtn.disabled = !ready;
        addBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');

        wrapper.querySelectorAll('.bundle-card').forEach(function (card) {
          var id      = card.dataset.variantId;
          var cardQty = state[id] ? state[id].qty : 0;
          var qtyEl = card.querySelector('.qty');

          card.classList.toggle('selected', cardQty > 0);
          if (qtyEl) qtyEl.textContent = String(cardQty);

          var plusBtn  = card.querySelector('.plus');
          var minusBtn = card.querySelector('.minus');

          if (plusBtn)  plusBtn.disabled  = (n >= activeMaxItems);
          if (minusBtn) minusBtn.disabled = (cardQty <= 0);
        });
      }

      if (quickViewAddBtn) {
        quickViewAddBtn.addEventListener('click', function () {
          if (!quickViewState || !quickViewState.card || !quickViewState.variantId) return;
          if (totalCount() >= activeMaxItems) {
            showToast('Bundle limit reached', 'info');
            closeQuickView();
            return;
          }

          var card = quickViewState.card;
          var selectedId = quickViewState.variantId;
          var selectedPrice = quickViewState.price;
          var selectedCompareAt = quickViewState.compareAt || 0;

          if (card.__applyVariant) {
            card.__applyVariant(selectedId, selectedPrice, selectedCompareAt);
          } else {
            card.dataset.variantId = selectedId;
            card.dataset.price = String(selectedPrice);
          }

          if (!state[selectedId]) state[selectedId] = { qty: 0, price: selectedPrice };
          state[selectedId].qty++;
          sync();
          closeQuickView();
        });
      }

      if (quickViewCloseEls && quickViewCloseEls.length) {
        quickViewCloseEls.forEach(function (node) {
          node.addEventListener('click', closeQuickView);
        });
      }

      if (quickViewPrev) {
        quickViewPrev.addEventListener('click', function () {
          if (!quickViewTrack || !quickViewTrack.clientWidth) return;
          quickViewTrack.scrollBy({ left: -quickViewTrack.clientWidth, behavior: 'smooth' });
        });
      }

      if (quickViewNext) {
        quickViewNext.addEventListener('click', function () {
          if (!quickViewTrack || !quickViewTrack.clientWidth) return;
          quickViewTrack.scrollBy({ left: quickViewTrack.clientWidth, behavior: 'smooth' });
        });
      }

      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && quickView && !quickView.hidden) {
          closeQuickView();
        }
      });

      function addAllToCart(items, onDone, onFail) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Add failed'); });
          return res.json();
        })
        .then(function () { onDone(); })
        .catch(function (err) { onFail(err); });
      }

      wrapper.querySelectorAll('.bundle-card').forEach(function (card) {
        var qtyEl     = card.querySelector('.qty');
        var plusBtn   = card.querySelector('.plus');
        var minusBtn  = card.querySelector('.minus');
        var sizeDataEls = card.querySelectorAll('.bundle-size-data-item');
        var priceEl = card.querySelector('.bundle-price');
        var compareEl = card.querySelector('.bundle-compare');
        var saveBadgeEl = card.querySelector('.bundle-save-badge');

        if (!card.dataset.variantId) return;

        card.addEventListener('click', function (evt) {
          if (!sizeDataEls || !sizeDataEls.length) return;
          if (evt.target.closest('.plus') || evt.target.closest('.minus')) return;
          openQuickView(card, sizeDataEls);
        });

        function applyVariant(selectedId, selectedPrice, selectedCompareAt) {
          var prevVariantId = card.dataset.variantId;
          var qty = state[prevVariantId] ? state[prevVariantId].qty : 0;

          card.dataset.variantId = selectedId;
          card.dataset.price = String(selectedPrice);

          if (qty > 0) {
            if (prevVariantId !== selectedId) delete state[prevVariantId];
            state[selectedId] = { qty: qty, price: selectedPrice };
          }

          if (priceEl) priceEl.textContent = formatMoney(selectedPrice);

          if (compareEl) {
            if (selectedCompareAt > selectedPrice) {
              compareEl.innerHTML = '<s>' + formatMoney(selectedCompareAt) + '</s>';
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }

          if (saveBadgeEl) {
            if (selectedCompareAt > selectedPrice) {
              var off = Math.round(((selectedCompareAt - selectedPrice) * 100) / selectedCompareAt);
              saveBadgeEl.textContent = saveLabel + ' ' + off + '%';
              saveBadgeEl.style.display = '';
            } else {
              saveBadgeEl.style.display = 'none';
            }
          }

          sync();
        }
        card.__applyVariant = applyVariant;

        plusBtn.addEventListener('click', function () {
          if (totalCount() >= activeMaxItems) {
            showToast('Bundle limit reached', 'info');
            return;
          }
          if (sizeDataEls && sizeDataEls.length) {
            if (openQuickView(card, sizeDataEls)) return;
          }
          var variantId = card.dataset.variantId;
          var unitPrice = parseInt(card.dataset.price, 10);
          if (!variantId || isNaN(unitPrice)) return;
          if (!state[variantId]) state[variantId] = { qty: 0, price: unitPrice };
          state[variantId].qty++;
          qtyEl.textContent = state[variantId].qty;
          sync();
          // showToast('Item added', 'info');
        });

        minusBtn.addEventListener('click', function () {
          var variantId = card.dataset.variantId;
          if (!variantId) return;
          if (!state[variantId] || state[variantId].qty <= 0) return;
          var newQty = state[variantId].qty - 1;
          state[variantId].qty = newQty;
          qtyEl.textContent = newQty;
          if (newQty === 0) delete state[variantId];
          sync();
          // showToast('Item removed', 'info');
        });
      });

      addBtn.addEventListener('click', function () {
        if (totalCount() !== activeMaxItems) {
          showToast('Please select exactly ' + activeMaxItems + ' items', 'info');
          return;
        }
        addBtn.disabled    = true;
        addBtn.setAttribute('aria-disabled', 'true');
        if (addBtnLabel) addBtnLabel.textContent = btnLoading;

        var items = [];
        var ids = Object.keys(state);
        for (var i = 0; i < ids.length; i++) {
          items.push({ id: parseInt(ids[i], 10), quantity: state[ids[i]].qty });
        }

        addAllToCart(items,
          function () {
            if (clearSelectionAfterAdd) {
              wrapper.querySelectorAll('.bundle-card').forEach(function (card) {
                var qtyNode = card.querySelector('.qty');
                if (qtyNode) qtyNode.textContent = '0';
              });
              state = {};
            }
            sync();
            if (addBtnLabel) addBtnLabel.textContent = 'Added to Cart';
            showToast('Bundle added to cart', 'success');
            setTimeout(function () {
              if (addBtnLabel) addBtnLabel.textContent = btnLabel;
            }, 1500);
          },
          function (err) {
            if (addBtnLabel) addBtnLabel.textContent = btnLabel;
            addBtn.disabled = false;
            addBtn.setAttribute('aria-disabled', 'false');
            showToast(err.message || errorMsg, 'error');
          }
        );
      });

      sync();
    }

    document.querySelectorAll('[id^="bundle-builder-"]').forEach(function (wrapper) {
      initBundle(wrapper);
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
     
class FilpClock extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute('data-countdown-input')).getTime();
    this.flipclock = this.querySelectorAll('[data-flip-clock]');
    this.timer_labels = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    var time = this.timeDifference(currentDate, this.targetDate);
    if (this.remainingTime <= 0) {

       const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
    }
    
   
   
    if ('IntersectionObserver' in window === false) return;
    const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initializeClock();
          observer.unobserve(this);
        }
    });
    }, { rootMargin: '0px 0px 700px 0px' });
    observer.observe(this);


    this.flipclock.forEach((flipClock) => { 
  var daysFirst = flipClock.querySelector('[data-days-first]');
  var hoursFirst = flipClock.querySelector('[data-hours-first]');
  var minutesFirst = flipClock.querySelector('[data-minutes-first]');
  var secondsFirst = flipClock.querySelector('[data-seconds-first]');


  if (daysFirst) {
    daysFirst.querySelector('[data-day]').value = time.days;
    daysFirst.querySelectorAll('[data-day-top]').forEach((element) => {
      element.textContent = time.days; 
    });
    daysFirst.querySelectorAll('[data-day-bottom]').forEach((element) => {
      element.textContent = time.days; 
    });
  }

  if (hoursFirst) {
    hoursFirst.querySelector('[data-hour]').value = time.hours;
    hoursFirst.querySelectorAll('[data-hour-top]').forEach((element) => {
      element.textContent = time.hours; 
    });
    hoursFirst.querySelectorAll('[data-hour-bottom]').forEach((element) => {
      element.textContent = time.hours; 
    });
  }

  if (minutesFirst) {
    minutesFirst.querySelector('[data-minute]').value = time.minutes;
    minutesFirst.querySelectorAll('[data-minute-top]').forEach((element) => {
      element.textContent = time.minutes; // Update top text for minutes
    });
    minutesFirst.querySelectorAll('[data-minute-bottom]').forEach((element) => {
      element.textContent = time.minutes; // Update bottom text for minutes
    });
  }

  if (secondsFirst) {
    secondsFirst.querySelector('[data-second]').value = time.seconds;
    secondsFirst.querySelectorAll('[data-second-top]').forEach((element) => {
      element.textContent = time.seconds; // Update top text for seconds
    });
    secondsFirst.querySelectorAll('[data-second-bottom]').forEach((element) => {
      element.textContent = time.seconds; // Update bottom text for seconds
    });
  }

});


  }

  initializeClock() {
  this.flipclock.forEach((flipClock) => { // Changed function to arrow function

    var daysFirst = this.createHandles(flipClock.querySelector('[data-days-first]'));
    var hoursFirst = this.createHandles(flipClock.querySelector('[data-hours-first]'));
    var minutesFirst = this.createHandles(flipClock.querySelector('[data-minutes-first]'));
    var secondsFirst = this.createHandles(flipClock.querySelector('[data-seconds-first]'));

    function updateClock() {
      var time = this.timeDifference(currentDate, this.targetDate); // Ensure 'this' refers to FilpClock instance
    

      this.flipDigit(daysFirst, Math.floor(time.days));

      this.flipDigit(hoursFirst, Math.floor(time.hours ));

      this.flipDigit(minutesFirst, Math.floor(time.minutes));
      this.flipDigit(secondsFirst, Math.floor(time.seconds));
   
      this.querySelector('[data-day]').value = time.days;
      this.querySelector('[data-hour]').value = time.hours;
      this.querySelector('[data-minute]').value = time.minutes;
      this.querySelector('[data-second]').value = time.seconds;
      
      if (time.total <= 0) {
        const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
      
        clearInterval(timeinterval);
      }
    }
    var currentDate = new Date().getTime(); // Define currentDate here
    var timeinterval = setInterval(updateClock.bind(this), 1000); // Bind updateClock to FilpClock instance
    });
  }


  timeDifference(current, target) {
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    return {
      'total': this.remainingTime,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  createHandles(flipElement) {
    var flipperTop = flipElement.querySelector("[flipper-top]");
    var flipperBottom = flipElement.querySelector("[flipper-bottom]");
    var flipperDisplayTop = flipElement.querySelector("[flip-display-top]");
    var flipperDisplayBottom = flipElement.querySelector("[flip-display-bottom]");
    var flipHiddenInput = flipElement.querySelector("[type='hidden']");
    return {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    };
  }

  flipDigit(flipHandles, digitValue) {
    var {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    } = flipHandles;

    var setPreviousValue = function(value) {
      flipperTop.innerText = value;
      flipperDisplayBottom.innerText = value;
    };
    var setAfterValue = function(value) {
      flipperDisplayTop.innerText = value;
      flipperBottom.innerText = value;
    };

    if (parseInt(flipHiddenInput.value) !== digitValue) {
      setPreviousValue(flipHiddenInput.value);
      flipHiddenInput.value = digitValue;
      var valueChangedEvent = new Event('valueChanged');
      flipHiddenInput.dispatchEvent(valueChangedEvent);
    }

    flipHiddenInput.addEventListener('valueChanged', function() {
      setAfterValue(flipHiddenInput.value);
      flipElement.classList.add("play");
    });

    flipperBottom.addEventListener('animationend', function() {
      setAfterValue(flipHiddenInput.value);
      setPreviousValue(flipHiddenInput.value);
      flipElement.classList.remove("play");
    });
  }
}
customElements.define('filpclock-counter', FilpClock);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
     
class FeatureProducts extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const currentSection = this.closest('.shopify-section');
    const offsetSection = currentSection.getBoundingClientRect();

    if (offsetSection.top < window.innerHeight && offsetSection.bottom > 70) {
      this.classList.add('is-active');
    }
  }
}

customElements.define('feature-products', FeatureProducts);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-accordion]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          console.log('e3ewqe');
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.style.setProperty('--progress_width', `${parseInt(this.dataset.value) * 0.75 * 100 / parseInt(this.dataset.max)}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-bar"] && !Shopify.designMode) return;
  try {
    
  class PromotionalBar extends HTMLElement {
    constructor() {
      super();

      const popupModal = this.querySelector('popup-modal');

      this.videos = this.querySelectorAll('[promotional-bar-video]');

      this.videos.forEach((video) => {
        video.addEventListener('click', () => {
          const videoId = video.getAttribute('data-id');
          console.log(videoId);
          popupModal.modalPopupOpen(`data-video-popup-${videoId}`);
        });
      });
    }
  }

  customElements.define('promotional-bar', PromotionalBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
     
class Textwithicon extends HTMLElement{
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(this.getHeight.bind(this));
    resizeObserver.observe(this);
    //this.getHeight();
  }
  getHeight(){
    this.divElement = this.querySelectorAll("[data-text-icon-desc]");
    this.divElement.forEach(element => {
      this.elemHeight = element.getBoundingClientRect().height;
      let closestParent = element.closest('[data-text-icon-inner]');
      if (closestParent) {
    
        closestParent.style.setProperty('--description_height', `${this.elemHeight}px`);
      }
    });
  }
}
customElements.define('text-with-icon', Textwithicon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
     
class AnimatedCursor extends HTMLElement {
  constructor() {
    super();

    this.mouse = { x: -100, y: -100 };
    this.pos = { x: 0, y: 0 };
    this.speed = 0.15;
    this.element = null; // Keep track of the current element with cursor class

    
    //window.addEventListener('mousedown', this.startDrag.bind(this));
   // window.addEventListener('mouseup', this.endDrag.bind(this));

    const cursorPointer = this.closest('.section-video');

    if(! cursorPointer){ 
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));  
        return; 
      }
    // window.addEventListener('mousedown', this.startDrag.bind(this));
    cursorPointer.querySelectorAll('[cursor-class]').forEach((cursorModifier) => {
     cursorModifier.addEventListener('pointermove', this.updateCoordinates.bind(this));
      cursorModifier.addEventListener('mouseenter', this.addCursorClass.bind(this));
      cursorModifier.addEventListener('mouseleave', this.removeCursorClass.bind(this));
      cursorModifier.addEventListener('mouseout', this.removeCursor.bind(this));
      cursorModifier.addEventListener('scroll', () => {
        console.log('Scroll event fired');
      });
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));
      cursorModifier.addEventListener('mouseup', this.endDrag.bind(this));
      cursorModifier.addEventListener('mousedown', this.startDrag.bind(this)); // Add mousedown event here
    });

    requestAnimationFrame(this.loop.bind(this));
  }

  startDrag(e) {
    this.updateCoordinates(e);
  }

  endDrag(e) {
    this.updateCoordinates(e);
  }

  removeCursor(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    this.elementName = event.target.tagName;
  }

  handleScroll(e){
    console.log("wqewqe");
  }
  updateCoordinates(e) {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  }

  getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
  }

  getSqueeze(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    const maxSqueeze = 0.0;
    const accelerator = 1500;
    return Math.min(distance / accelerator, maxSqueeze);
  }

  updateCursor() {
    const diffX = Math.round(this.mouse.x - this.pos.x);
    const diffY = Math.round(this.mouse.y - this.pos.y);

    this.pos.x += diffX * this.speed;
    this.pos.y += diffY * this.speed;

    const angle = this.getAngle(diffX, diffY);
    const squeeze = this.getSqueeze(diffX, diffY);

    // Update cursor style with transformations
    this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
    //this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg) translate3d(${this.pos.x}px, ${this.pos.y}px, 0)`;
  }

  loop() {
    this.updateCursor();
    requestAnimationFrame(this.loop.bind(this));
  }

  addCursorClass(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    if (className === 'video') {
      this.classList.add('king_cursor');
      this.videoButton = this.element.querySelector('[data-content-button]');
     
      if(this.videoButton){
      this.videoButton.style.display = "none";
      }
      this.innerHTML = this.videoButton.innerHTML;
    }
  }

  removeCursorClass(event) {
    const element = event.currentTarget;
    console.log(element);
    const className = element.getAttribute('cursor-class');
    if (className === 'video') {
      this.videoButton = this.element.querySelector('[data-content-button]');
      if(this.videoButton){
      this.videoButton.style.display = "block";
      }
      this.innerHTML = '';
      this.classList.remove('king_cursor');
    }
  }
}

customElements.define('animated-cursor', AnimatedCursor);


  } catch(e) { console.error(e); }
})();
})();
